// extracted by mini-css-extract-plugin
export default {"OptionsHeading":"single-select-options-module__OptionsHeading__Qo4oF5D","SingleSelectForm":"single-select-options-module__SingleSelectForm__BLIcXOz"};